import React from 'react'

export default function Navbar() {
  return (
    <div className='navbar' >

         <p className='program'> Programmer </p> 
   

      <div style={{display : 'flex'}} >
          <div className='navItems' >
          <a onClick={() => {window.location.href="https://www.linkedin.com/in/sahil-rohera-202939214/"}}> <p>LinkedIn</p> </a>
          </div>
          <div className='navItems' >
          <a onClick={() => {window.location.href="https://github.com/sahilrohera10"}}> <p>GitHub</p> </a>
          </div>
          <div className='navItems'  >
          <a onClick={() => {window.location.href="https://www.instagram.com/sahilrohera10/"}}> <p>Instagram</p> </a>
          </div>
      </div>

      

    </div>
  )
}
